import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
    list: [],
    salaryHistory: [],
    error: "",
    loading: false,
};

export const addUserSalary = createAsyncThunk(
    "salaryHistory/addUserSalary",
    async (values) => {
        try {
            const { data } = await axios({
                method: "post",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                },
                url: `salaryHistory/salary`,
                data: {
                    ...values,
                },
            });
            toast.success("salaryHistory Added");
            return {
                data,
                message: "success",
            };
        } catch (error) {
            toast.error("Error in adding salaryHistory try again");
            // console.log(error.message);
            return {
                message: "error",
            };
        }
    }
);

export const updateUserSalary = createAsyncThunk(
    "salaryHistory/updateUserSalary",
    async ({values, id}) => {
        try {
            const { data } = await axios({
                method: "put",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                },
                url: `salaryHistory/salary/${id}`,
                data: {
                    ...values,
                },
            });
            toast.success("salaryHistory updated");
            return {
                data,
                message: "success",
            };
        } catch (error) {
            toast.error("Error in adding salaryHistory try again");
            // console.log(error.message);
            return {
                message: "error",
            };
        }
    }
);

export const deleteSalaryHistory = createAsyncThunk(
    "salaryHistory/deleteSalaryHistory",
    async (id) => {
        try {
            const resp = await axios({
                method: "patch",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                },
                url: `salaryHistory/${id}`,
                data: {
                    status: false,
                },
            });

            return resp.data.id;
        } catch (error) {
            // console.log(error.message);
        }
    }
);


export const loadSalaryByUserId = createAsyncThunk(
    "salaryHistory/loadSalaryByUserId",
    async (userId, { rejectWithValue }) => {
      try {
        const { data } = await axios.get(`/salaryHistory/salary/${userId}`);
        return data;
      } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message);
      }
    }
  );



const salaryHistorySlice = createSlice({
    name: "salaryHistory",
    initialState,
    reducers: {
        clearSalaryHistory: (state) => {
            state.salaryHistory = null;
        },
    },
    extraReducers: (builder) => {
        // 1) ====== builders for loadSalaryByUserId ======

        builder.addCase(loadSalaryByUserId.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(loadSalaryByUserId.fulfilled, (state, action) => {
            state.loading = false;
            state.list = action.payload;
        });

        builder.addCase(loadSalaryByUserId.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
        });


        // 2) ====== builders for addUserSalary ======

        builder.addCase(addUserSalary.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(addUserSalary.fulfilled, (state, action) => {
            state.loading = false;
        });

        builder.addCase(addUserSalary.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
        });

        // 2) ====== builders for updateUserSalary ======

        builder.addCase(updateUserSalary.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(updateUserSalary.fulfilled, (state, action) => {
            state.loading = false;
        });

        builder.addCase(updateUserSalary.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
        });

        // 4) ====== builders for deleteSalaryHistory ======

        builder.addCase(deleteSalaryHistory.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(deleteSalaryHistory.fulfilled, (state, action) => {
            state.loading = false;
            const filterCategory = state.list.filter(
                (category) => category.id !== parseInt(action.payload) && category
            );
            state.list = filterCategory;

            const filterDesignation = state.list.filter(
                (desig) => desig.id !== parseInt(action.payload) && desig
            );

            state.list = filterDesignation;
        });

        builder.addCase(deleteSalaryHistory.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
        });
    },
});

export default salaryHistorySlice.reducer;
export const { clearSalaryHistory } = salaryHistorySlice.actions;
